/**
 * 枚举
 */
 
// 数据类型
const DATA_TYPE = {
    ENUM: "枚举",
    STRING: "文本",
    NUMBER: "数值",
    TIME: "时间",
    JSONArray: "数组"
}

// 数据类型
const TIME_SELECTOR = {
    T_DAY: "今天",
    Y_DAY: "昨天",
    DBY_DAY: "前天",
    L_SEVEN_DAY: "过去7天",
    L_TWO_WEEK: "过去14天",
    MONTH: "本月",
    L_MONTH: "上月"
}

// 下载中心状态
const FILE_STATUS = {
  1: {
    class: "waiting",
    text: "排队中"
  },
  10: {
    class: "preparation",
    text: "数据准备中"
  },
  15: {
    class: "success",
    text: "下载成功"
  },
  20: {
    class: "failure",
    text: "下载失败"
  }
}

const ChartDefaultColor = [
  { color: "#3BD351" },
  { color: "#2478ff" },
  { color: "#fbbc00" },
  { color: "#E96469" },
  { color: "#C369EA" },
  { color: "#F69925" },
  { color: "#65B5EE" },
  { color: "#AECA3E" },
  { color: "#55D2DE" },
  { color: "#23C276" },
  { color: "#677392" },
];

const ChartOptionsColor = [ "#3BD351", "#2478ff", "#fbbc00", "#E96469","#C369EA", "#F69925", "#65B5EE", "#AECA3E","#55D2DE", "#23C276", "#677392",]
const ChartCompareColor = [
  { color: "#3BD351" },
  { color: "#9DE9A8" },
  { color: "#2478ff" },
  { color: "#A0BBFF" },
  { color: "#fbbc00" },
  { color: "#FDDE80" },
  { color: "#E96469" },
  { color: "#F4AFB2" },
  { color: "#C369EA" },
  { color: "#E1B4F5" },
  { color: "#F69925" },
  { color: "#FACC92" },
  { color: "#65B5EE" },
  { color: "#B2D9F7" },
  { color: "#AECA3E" },
  { color: "#D6E0AE" },
  { color: "#55D2DE" },
  { color: "#AAE8EF" },
  { color: "#23C276" },
  { color: "#91E0BB" },
  { color: "#677392" },
  { color: "#B3B9C8" },
];

const ChartCompareOptionsColor = [ "#3BD351", "#3BD351","#2478ff","#2478ff",
 "#fbbc00","#fbbc00", "#E96469", "#E96469","#C369EA","#C369EA", "#F69925","#F69925",
  "#65B5EE","#65B5EE", "#AECA3E","#AECA3E","#55D2DE","#55D2DE", "#23C276","#23C276", "#677392","#677392",]
const  FrequencyList = [
    {
      name: '每小时',
      value: 'EVERY_HOUR'
    },
    {
      name: '每天',
      value: 'EVERY_DAY'
    },
    {
      name: '每周',
      value: 'EVERY_WEEK'
    },
    {
      name: '每月',
      value: 'EVERY_MONTH'
    },
  ]
const WeekList = [
    {
      name: '周一',
      value: '1'
    },
    {
      name: '周二',
      value: '2'
    },
    {
      name: '周三',
      value: '3'
    },
    {
      name: '周四',
      value: '4'
    },
     {
      name: '周五',
      value: '5'
    },
     {
      name: '周六',
      value: '6'
    },
    {
      name: '周日',
      value: '7'
    },
  ]
const GetMonthList = () => {
  let arr =[];
  for (let index = 0; index < 31; index++) {
    const obj = {
      name: `${index +1}号`,
      value: `${index +1}`
    }
    arr.push(obj);
  }
  return arr;
}
const SHARE_STATUS = {
  1: {
    class: "success",
    text: "已分享"
  },
  0: {
    class: "cancel",
    text: "已取消"
  }
}
export default {
    DATA_TYPE,
    TIME_SELECTOR,
    FILE_STATUS,
    SHARE_STATUS,
    ChartDefaultColor,
    ChartOptionsColor,
    ChartCompareColor,
    ChartCompareOptionsColor,
    FrequencyList,
    WeekList,
    GetMonthList

};